import React from 'react';
import { cn } from './lib/utils';

export const IconWrap = React.memo(function IconWrap({ className = '', size = '', enlarge = '', children, ...etc }) {
  return (
    <span
      {...etc}
      className={cn('ui-icon', className)}
      data-size={size}
      data-enlarge={enlarge}
    >
      {children}
    </span>
  );
});

export const Icon = React.memo(function Icon({ name, ...etc }) {
  if (!name) return null;

  var iconName;
  try {
    iconName =
      '#' +
      require('~assets/icons/' +
        (etc.size ? etc.size + '_' : '') +
        name +
        '.svg').default.id;
  } catch (e) {}

  return (
    <IconWrap {...etc}>
      <svg>
        <use xlinkHref={iconName} />
      </svg>
    </IconWrap>
  );
});

export function Avatar({ src, className = '', ...etc }) {
  if (!src)
    return (
      <Icon
        {...etc}
        className={cn('ui-avatar-default', className)}
        name='user'
      />
    );

  return (
    <IconWrap {...etc} className={cn('ui-avatar', className)}>
      <img src={src} alt=' ' />
    </IconWrap>
  );
}

export function IconNumber({ className = '', children, ...etc }) {
  const val = parseInt(children) || 0;
  return (
    <IconWrap {...etc} className={cn('ui-icon-number', className)}>
      <span className='ui-icon-number-text'>{val > 9 ? '9+' : val}</span>
    </IconWrap>
  );
}

export default Icon;
